var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextlevelicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Next_level_icon",
    "data-name": "Next level icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_21",
    "data-name": "Polygon 21",
    d: "M7,0l7,9H0Z",
    transform: "translate(9) rotate(90)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextlevelicon);
export default __webpack_public_path__ + "static/media/Next level icon.f054e8cc750386149f6e65ef1a616b81.svg";
export { ForwardRef as ReactComponent };